import React from 'react';
import { Menu, FolderOpen } from 'lucide-react';
import { googleLogout } from '@react-oauth/google';
import { useNavigate } from 'react-router-dom';
import { LogOut } from 'lucide-react';

const LogoutButton = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    try {
      // 1. Trigger the official library logout sequence
      googleLogout();

      // 2. Clear your application's local session tokens and user data
      localStorage.removeItem('token');
      localStorage.removeItem('user'); // מנקים גם את נתוני המשתמש

      // 3. Optional: Clear any user context/state here if you use it globally
      // setUser(null);
      
      // 4. Redirect the user back to the authentication page
      navigate('/auth'); // or wherever your AuthPage is mounted
    } catch (error) {
      console.error('Error during client logout sequence:', error);
    }
  };

  return (
    <button
      onClick={handleLogout}
      className="flex items-center gap-2 px-3 py-1.5 text-sm font-medium text-rose-600 hover:bg-rose-50 rounded-xl transition-colors"
    >
      <LogOut className="w-4 h-4" />
      <span>התנתקות</span>
    </button>
  );
}

// קומפוננטת פרופיל חדשה שמציגה את נתוני המשתמש מגוגל
const UserProfile = () => {
  const userData = localStorage.getItem('user');
  
  if (!userData) return null;

  try {
    const user = JSON.parse(userData);
    
    return (
      <div className="flex items-center gap-3 pl-3 border-l border-slate-200">
        <img 
          src={user.picture} 
          alt={user.name} 
          className="w-8 h-8 rounded-full object-cover border border-slate-200"
          referrerPolicy="no-referrer" // מונע בעיות טעינת תמונות מגוגל בחלק מהדפדפנים
        />
        <div className="flex flex-col text-right">
          <span className="text-sm font-medium text-slate-800 leading-none">{user.name}</span>
          <span className="text-xs text-slate-400 mt-0.5">{user.email}</span>
        </div>
      </div>
    );
  } catch (error) {
    console.error("Error parsing user data from localStorage", error);
    return null;
  }
}

export default function Navbar({ onMenuClick, totalFilesCount, title = 'ניהול הקבלות שלי', showFilesCount = false }) {
  return (
    <nav className="w-full bg-white/80 backdrop-blur-md sticky top-0 z-40 border-b border-slate-100 px-6 py-4 flex items-center justify-between" dir="rtl">
      {/* צד ימין: תפריט וכותרת */}
      <div className="flex items-center gap-3">
        <button
          onClick={onMenuClick}
          className="p-2 hover:bg-slate-100 rounded-xl transition-colors text-slate-600 focus:outline-none"
        >
          <Menu className="w-5 h-5" />
        </button>

        {/* שים לב: שיניתי ל-border-l ו-pl-3 כדי שיתאים לעברית (RTL) */}
        <div className="flex items-center gap-3 border-l border-slate-200 pl-3">
          <div className="w-8 h-8 rounded-full bg-slate-100 flex items-center justify-center text-slate-600">
            <FolderOpen className="w-4 h-4 text-indigo-600" />
          </div>
          <div>
            <h1 className="font-semibold text-sm text-slate-900 tracking-tight">{title}</h1>
          </div>
        </div>
      </div>

      {/* מרכז: כמות קבצים */}
      {showFilesCount && (
        <div className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-slate-100 border border-slate-200/40">
          <span className="w-2 h-2 rounded-full bg-emerald-500" />
          <span className="text-xs font-medium text-slate-600">
            {totalFilesCount} קבצים במערכת
          </span>
        </div>
      )}

      {/* צד שמאל: פרופיל משתמש וכפתור התנתקות */}
      {localStorage.getItem("token") != null ? (
        <div className="flex items-center gap-2 p-1.5 rounded-full bg-slate-50 border border-slate-200/60">
          <UserProfile />
          <LogoutButton />
        </div>
      ) : null}
    </nav>
  );
}